export default __webpack_public_path__ + "static/media/5.15.19d51afb.mp3";